// Mirrors the touch control clusters: steering arrows move to the
// right thumb, BRAKE/BOOST move to the left. Persisted across sessions.
// Layout-only — input semantics don't change (touch-left still steers
// left, etc.); CSS just relocates the buttons.

const STORAGE_KEY = 'tst:lefty-layout';

type Listener = (enabled: boolean) => void;

const listeners = new Set<Listener>();
let enabled = readEnabled();

export const leftyLayout = {
  isEnabled(): boolean {
    return enabled;
  },
  setEnabled(next: boolean): void {
    if (next === enabled) return;
    enabled = next;
    writeEnabled(next);
    applyLefty(next);
    for (const l of listeners) l(next);
  },
  toggle(): boolean {
    leftyLayout.setEnabled(!enabled);
    return enabled;
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

/** Sync the body class so CSS rules pick up the override. */
export function applyLefty(value: boolean): void {
  if (typeof document === 'undefined') return;
  document.body.classList.toggle('is-lefty', value);
}

function readEnabled(): boolean {
  try {
    return typeof localStorage?.getItem === 'function'
      ? localStorage.getItem(STORAGE_KEY) === '1'
      : false;
  } catch {
    return false;
  }
}

function writeEnabled(value: boolean): void {
  try {
    if (typeof localStorage?.setItem === 'function') {
      localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
    }
  } catch {
    // Ignore storage failures in embedded/test environments.
  }
}
